import { IconLookup, IconName, IconParams, icon } from '@fortawesome/fontawesome-svg-core';

export function getBlockLabel(
  label: string,
  iconDef: IconName | IconLookup | string,
  iconParams: IconParams,
) {
  return `<div>
    <div class="block-icon">
      ${typeof iconDef === 'string' ? iconDef : icon(iconDef, iconParams).html}
    </div>
    <div>${label}</div>
  </div>`;
}
